<div class="commission-list ui-page-skeleton-modern">
  <div class="container">
    <div class="container-conteudo conteudo d-flex direction-column">
      <!-- <div class="conteudo-page-header page-header d-flex align-center">
        <span class="page-header-separator" aria-hidden="true"></span>
        <h1 class="page-header-title">Comissão de Faturamento</h1>
      </div> -->

      <div class="conteudo-filters">
        <section class="filter-accordion">
          <button type="button" class="filter-accordion-header" (click)="toggleFiltersVisibility()"
            [attr.aria-expanded]="isFiltersExpanded" aria-controls="commission-filter-body">
            <span class="filter-accordion-title">Filtros</span>
            <span class="filter-accordion-toggle-label">{{ isFiltersExpanded ? 'ocultar' : 'mostrar' }}</span>
          </button>

          <div class="filter-accordion-body" id="commission-filter-body" *ngIf="isFiltersExpanded">
            <section class="filter-panel">

              <div class="contexts-grid">
                <div class="commission-filter-field">
                  <label class="ui-field-label" for="commission-filter-banks-trigger">Bancos</label>
                  <div class="commission-combo-wrap" role="presentation" (appOutsideClick)="closeDropdown()"
                    (click)="$event.stopPropagation()">
                    <button id="commission-filter-banks-trigger" class="commission-combo-trigger" type="button" (click)="toggleDropdown($event, 'banks')">
                      <span>{{ getBankTriggerText() }}</span>
                      <span class="commission-combo-arrow">&#9660;</span>
                    </button>

                    <div class="combo-dropdown" role="presentation" *ngIf="openDropdown === 'banks'" (click)="$event.stopPropagation()">
                      <label class="combo-option" *ngFor="let bank of banks">
                        <input class="commission-combo-checkbox" type="checkbox" [checked]="isBankSelected(bank.BankId)"
                          (change)="toggleBank(bank.BankId, $any($event.target).checked)" />
                        <span class="commission-combo-option-text">{{ bank.Name }}</span>
                      </label>
                    </div>
                  </div>
                </div>

                <div class="commission-filter-field">
                  <label class="ui-field-label" for="commission-filter-periods-trigger">Períodos</label>
                  <div class="commission-combo-wrap" role="presentation" (appOutsideClick)="closeDropdown()"
                    (click)="$event.stopPropagation()">
                    <button id="commission-filter-periods-trigger" class="commission-combo-trigger" type="button" (click)="toggleDropdown($event, 'periods')">
                      <span>{{ getPeriodTriggerText() }}</span>
                      <span class="commission-combo-arrow">&#9660;</span>
                    </button>

                    <div class="combo-dropdown combo-dropdown--periods" role="presentation" *ngIf="openDropdown === 'periods'"
                      (click)="$event.stopPropagation()">
                      <label class="combo-option" *ngFor="let period of periods">
                        <input class="commission-combo-checkbox" type="checkbox" [checked]="isPeriodSelected(period)"
                          (change)="togglePeriod(period, $any($event.target).checked)" />
                        <span class="commission-combo-option-text">{{ period }}</span>
                      </label>
                    </div>
                  </div>
                </div>

                <div class="commission-filter-field">
                  <label class="ui-field-label" for="commission-filter-products-trigger">Produtos</label>
                  <div class="commission-combo-wrap" role="presentation" (appOutsideClick)="closeDropdown()"
                    (click)="$event.stopPropagation()">
                    <button id="commission-filter-products-trigger" class="commission-combo-trigger" type="button" (click)="toggleDropdown($event, 'products')">
                      <span>{{ getProductTriggerText() }}</span>
                      <span class="commission-combo-arrow">&#9660;</span>
                    </button>

                    <div class="combo-dropdown" role="presentation" *ngIf="openDropdown === 'products'" (click)="$event.stopPropagation()">
                      <label class="combo-option" *ngFor="let product of products">
                        <input class="commission-combo-checkbox" type="checkbox"
                          [checked]="isProductSelected(product.ProductId)"
                          (change)="toggleProduct(product.ProductId, $any($event.target).checked)" />
                        <span class="commission-combo-option-text">{{ product.Name }}</span>
                      </label>
                    </div>
                  </div>
                </div>

                <div class="commission-list__summary-row">
                  <div class="commission-list__filter-actions">
                    <button type="button" class="ui-btn ui-btn--secondary" (click)="clearCommissionFilters()">
                      Limpar filtros
                    </button>

                    <button type="button" class="ui-btn ui-btn--primary" (click)="applyCommissionFilters()">
                      Buscar
                    </button>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </section>
      </div>

      <div class="conteudo-list" #commissionHeaderRegion>
        <div class="conteudo-list-placeholder" *ngIf="isCommissionHeaderPinned"
          [style.height.px]="commissionHeaderHeight">
        </div>

        <div #commissionHeaderFix class="conteudo-list-fix" [class.conteudo-list-fix-pinned]="isCommissionHeaderPinned"
          [style.left.px]="isCommissionHeaderPinned ? commissionHeaderLeft : null"
          [style.width.px]="isCommissionHeaderPinned ? commissionHeaderWidth : null">
          <div class="conteudo-list-toolbar toolbar d-flex align-center">
            <button type="button" class="ui-btn ui-btn--primary ui-btn--lg" (click)="openDialogCommission()">
              <app-svg-icon src="../../../../assets/icons/vector-comissao.svg" color="black" width="12px" height="12px">
              </app-svg-icon>
              <span>Comissão</span>
            </button>
          </div>

          <div class="conteudo-list-header header d-flex align-center">
            <app-ordered-header-list class="is-grid" [headerItems]="headerItems" >
              <div buttonSpace class="header-spacer-action"></div>
            </app-ordered-header-list>
          </div>
        </div>

        <div #commissionListBody class="conteudo-contracts contracts d-flex direction-column row-gap-8">
          <app-skeleton *ngIf="isLoading" variant="table-row" [rows]="8" [columns]="headerItems.length"></app-skeleton>

          <ng-container *ngIf="!isLoading">
            <div *ngIf="commissionList.length > 0" class="commission-list__cards">
              <ng-container *ngFor="let commission of commissionList">
                <app-comissao-card [commission]="commission"
                  [parametersCommission]="parametersCommission"></app-comissao-card>
              </ng-container>
            </div>

            <div *ngIf="commissionList.length === 0" class="contracts-empty empty mt-20">
              <span class="empty-message">Sem comissões disponíveis</span>
            </div>
          </ng-container>
        </div>

      </div>

    </div>
  </div>

  <ng-container *ngIf="count > commissionList.length">
    <app-scroll-pagination [count]="count" [itemsPerSection]="searchFilter.Take" [resetKey]="paginationResetKey"
      (viewMoreTrigger)="handlePagination($event)"></app-scroll-pagination>
  </ng-container>
</div>